import { createSelector } from 'reselect'

export const getAppInternalTransitionFunc = createSelector(
  state => state && state.common && state.common.transitions && state.common.transitions.internalTransitionFunc ? state.common.transitions.internalTransitionFunc : null,
  func => func
)
